import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './sagas';

// Import page reducers
import loginReducer from '../pages/Login/slice';
import accountsReducer from '../pages/Users/Accounts/slice';
import rolesReducer from '../pages/Users/Roles/slice';
import approvalAccountsReducer from '../pages/Users/ApprovalAccounts/slice';
import accountManagementReducer from '../pages/Users/AccountManagement/slice';
import unitsReducer from '../pages/Catalog/Units/slice';
import vehiclesReducer from '../pages/Catalog/Vehicles/slice';
import vehicleTypesReducer from '../pages/Catalog/VehicleTypes/slice';
import entryExitReasonsReducer from '../pages/Catalog/EntryExitReasons/slice';
import licensesReducer from '../pages/LicenseManagement/Licenses/slice';
import firmwareVersionsReducer from '../pages/LicenseManagement/FirmwareVersions/slice';
import devicesReducer from '../pages/DeviceManagement/Devices/slice';
import deviceConfigReducer from '../pages/DeviceManagement/DeviceConfiguration/slice';
import positionsReducer from '../pages/Catalog/Positions/slice';
import officerGroupsReducer from '../pages/Catalog/OfficerGroups/slice';
import visitTypesReducer from '../pages/Catalog/VisitTypes/slice';
import visitTypeCategoriesReducer from '../pages/Catalog/VisitTypeCategories/slice';
import entryExitStatusesReducer from '../pages/Catalog/EntryExitStatuses/slice';
import identityTypesReducer from '../pages/Catalog/IdentityTypes/slice';
import verifyModesReducer from '../pages/Catalog/VerifyModes/slice';
import accessReportReducer from '../pages/Reports/AccessReport/slice';
import deviceReportReducer from '../pages/Reports/DeviceReport/slice';
import databaseAnalysisReducer from '../pages/Reports/DatabaseAnalysis/slice';
import violationStatisticsReducer from '../pages/Reports/ViolationStatistics/slice';
import settingsReducer from '../pages/System/Settings/slice';
import systemLogsReducer from '../pages/System/SystemLogs/slice';
import vneidStatisticsReducer from '../pages/Statistics/VNeIDStatistics/slice';
import verificationQueriesReducer from '../pages/Statistics/VNeIDVerificationQueries/slice';
import vneidSdkReducer from '../pages/Statistics/VNeIDStatistics/sliceTab4';
import queryMonitoringReducer from '../pages/Statistics/VNeIDStatistics/sliceTab5';
import backupLogsReducer from '../pages/Reports/BackupLogs/slice';
import lgspIntegrationReducer from '../pages/Reports/LGSPIntegration/slice';
import dashboardReducer from '../pages/Dashboard/slice';
import syncDataReducer from '../pages/Backup/SyncData/slice';
import systemBackupReducer from '../pages/Backup/SystemBackup/slice';
import unitsBackupReducer from '../pages/Backup/UnitsBackup/slice';
import btl86BackupReducer from '../pages/Backup/BTL86Backup/slice';
import notificationsReducer from '../components/NotificationIcon/slice';
import alertConfigurationsReducer from '../pages/System/AlertConfigurations/slice';
import licenseUnitsReducer from '../pages/LicenseManagement/LicenseUnits/slice';

// Create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// Configure store with reducer and saga middleware
export const store = configureStore({
  reducer: {
    login: loginReducer,
    accounts: accountsReducer,
    roles: rolesReducer,
    approvalAccounts: approvalAccountsReducer,
    accountManagement: accountManagementReducer,
    units: unitsReducer,
    vehicles: vehiclesReducer,
    vehicleTypes: vehicleTypesReducer,
    entryExitReasons: entryExitReasonsReducer,
    licenses: licensesReducer,
    firmwareVersions: firmwareVersionsReducer,
    devices: devicesReducer,
    deviceConfig: deviceConfigReducer,
    positions: positionsReducer,
    officerGroups: officerGroupsReducer,
    visitTypeCategories: visitTypeCategoriesReducer,
    entryExitStatuses: entryExitStatusesReducer,
    identityTypes: identityTypesReducer,
    verifyModes: verifyModesReducer,
    visitTypes: visitTypesReducer,
    accessReport: accessReportReducer,
    deviceReport: deviceReportReducer,
    databaseAnalysis: databaseAnalysisReducer,
    violationStatistics: violationStatisticsReducer,
    settings: settingsReducer,
    systemLogs: systemLogsReducer,
    vneidStatistics: vneidStatisticsReducer,
    verificationQueries: verificationQueriesReducer,
    vneidSdk: vneidSdkReducer,
    queryMonitoring: queryMonitoringReducer,
    backupLogs: backupLogsReducer,
    lgspIntegration: lgspIntegrationReducer,
    dashboard: dashboardReducer,
    syncData: syncDataReducer,
    systemBackup: systemBackupReducer,
    unitsBackup: unitsBackupReducer,
    btl86Backup: btl86BackupReducer,
    notifications: notificationsReducer,
    alertConfigurations: alertConfigurationsReducer,
    licenseUnits: licenseUnitsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: false,
    }).concat(sagaMiddleware),
});

// Run the root saga
sagaMiddleware.run(rootSaga);

export default store;
